exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * @license\n * Copyright Akveo. All Rights Reserved.\n * Licensed under the MIT License. See License.txt in the project root for license information.\n */\n:host {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center; }\n  :host /deep/ nb-action {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center; }\n    :host /deep/ nb-action:first-child {\n      border-left: none !important; }\n    :host /deep/ nb-action i.control-icon:hover {\n      cursor: pointer; }\n    :host /deep/ nb-action.disabled {\n      cursor: not-allowed; }\n      :host /deep/ nb-action.disabled > * {\n        opacity: 0.5; }\n      :host /deep/ nb-action.disabled a, :host /deep/ nb-action.disabled i {\n        cursor: not-allowed !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /srv/dev/FitRadioAdmin2/src/app/@nebular/theme/components/actions/actions.component.scss
// module id = ../../../../../src/app/@nebular/theme/components/actions/actions.component.scss
// module chunks = main